import * as React from "react";
import { useFramesEcommContext } from "../../../../../../../context/modules/EcommContent/FramesEcommContent/context/FramesEcommContext.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { ProductDetailCTA } from "../../../../../../../../components/CTAs/ProductDetailCTA/modules/EcommContent/components/CTAs/ProductDetailCTA/ProductDetailCTA.js";
const FramesCTA = () => {
  const {
    activeVariant: { sku }
  } = useProductData();
  const { productAction, handleConfiguratorOpen, selectedOffering } = useFramesEcommContext();
  const handleConversionEvent = React.useCallback(() => {
  }, []);
  const onAddToCartSuccess = React.useCallback(() => {
  }, []);
  return /* @__PURE__ */ React.createElement(
    ProductDetailCTA,
    {
      action: productAction,
      handleConfiguratorOpen,
      handleConversionEvent,
      addToCartConfig: {
        activeSku: sku,
        offeringSku: selectedOffering?.sku,
        bundleLineItemSkus: selectedOffering?.bundledProductSkus,
        onSuccess: onAddToCartSuccess
      }
    }
  );
};
export {
  FramesCTA
};
//# sourceMappingURL=FramesCTA.js.map
